import React, { createContext, useReducer } from 'react'

export const SET_HARNESS_DATA = 'set_harness_data'
export const UPDATE_CHANGE_HARNESS_DATA = 'update_change_harness_data'
export const SET_SELECTED_HARNESS_DATA = 'set_selected_harness_data'
export const SHOW_HIDE_HARNESS_SALES_CODE_POPUP =
  'SHOW_HIDE_HARNESS_SALES_CODE_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_HARNESS_DATA: {
      return { ...data, data: payload.data }
    }
    case UPDATE_CHANGE_HARNESS_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData }
    }
    case SET_SELECTED_HARNESS_DATA: {
      return { ...data, selectedObject: payload.data }
    }
    case SHOW_HIDE_HARNESS_SALES_CODE_POPUP: {
      return { ...data, harnessSalesCodePopup: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedObject: {},
  harnessSalesCodePopup: {},
}

const HarnessListStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <HarnessListContext.Provider value={[state, dispatch]}>
      {children}
    </HarnessListContext.Provider>
  )
}

export const HarnessListContext = createContext(initialState)
export default HarnessListStore
